import { apiClient } from "./api-client";
import { toArray } from "./api-utils";
import type { TriyoTask } from "@/types/models";

export const TasksApi = {
  getUserTasks: async (): Promise<TriyoTask[]> => {
    const res = await apiClient.get<unknown>("/tasks/GetUserTaskListForAddin");
    return toArray<TriyoTask>(res.data, "Tasks", "tasks");
  },
};
